import { createAction, createReducer } from "@reduxjs/toolkit"
import httpClient from "./httpClient"

export const GET_TEMPLATE_RESPONSE = createAction("GET_TEMPLATE_RESPONSE")
export const GET_VARIABLES_RESPONSE = createAction("GET_VARIABLES_RESPONSE")

function fetchTemplate(type) {
  return (dispatch) =>
    httpClient.get(`/api/template/html/${type}`).then(({ data }) => {
      dispatch(GET_TEMPLATE_RESPONSE(data))
    })
}
function fetchVariables(type) {
  return (dispatch) =>
    httpClient.get(`/api/template/listVariable/${type}`).then(({ data }) => {
      dispatch(GET_VARIABLES_RESPONSE(data))
    })
}

function saveOrUpdate(template) {
  return (dispatch) =>
    httpClient.post("/api/templateMailer", template).then(() => {
      dispatch(fetchTemplate(template.type))
      dispatch(fetchVariables(template.type))
    })
}

function testSendMail(template) {
  return httpClient.post("/api/template/testSendMail", template)
}
const initialState = {
  template: {}
}
const reducer = createReducer(initialState, {
  GET_TEMPLATE_RESPONSE: (state, { payload }) => ({
    ...state,
    body: payload
  }),
  GET_VARIABLES_RESPONSE: (state, { payload }) => ({
    ...state,
    variables: payload
  })
})
export default {
  initialState,
  actions: {
    fetchTemplate,
    saveOrUpdate,
    fetchVariables,
    testSendMail
  },
  reducer
}
